module.exports = __webpack_public_path__ + "static/img/sabre.d23e66e8.png";